import { events } from '../../events';
import { BaseComponent } from '../../framework/base.component';
import { component } from '../../framework/component.decorator';
import { OnInit } from '../../framework/on-init.interface';
import { button$ } from '../../framework/templating/button.element';
import { icon$ } from '../../framework/templating/icon.element';
import styles from './stop-recording-trigger.component.scss';

@component({
  selector: 'app-stop-recording-trigger',
  styles,
})
export class StopRecordingTriggerComponent
  extends BaseComponent<StopRecordingTriggerComponent>
  implements OnInit
{
  async createInitialComponent(): Promise<HTMLElement | HTMLElement[]> {
    return button$(
      {
        onCreate: (element) => {
          element.title = 'Click to stop recording';
          element.disabled = true;

          element.addEventListener('click', () =>
            events.emit('stop-recording')
          );
        },
      },
      [icon$('stop-fill')]
    );
  }

  async onInit() {
    events.on('start-recording', () =>
      this.doOnFirstChild<HTMLButtonElement>((btn) => (btn.disabled = false))
    );

    events.on('stop-recording', () =>
      this.doOnFirstChild<HTMLButtonElement>((btn) => (btn.disabled = true))
    );
  }
}
